<template>
    <FieldContainer v-slot="{ field, fieldClasses }" disable-prepend disable-append>
        <select
            :id="field.id"
            :name="field.multiple ? `${field.handle}[]` : field.handle"
            :required="field.isRequired"
            :multiple="field.multiple"
            class="w-full field-custom field-in-group"
            :title="field.label || field.placeholder"
            :class="fieldClasses"
        >
            <option v-if="! field.multiple" value selected hidden disabled>{{ field.placeholder || 'Please select...' }}</option>

            <template v-for="(label, value) in fieldOptions">
                <option :value="value" :selected="isSelected(value)">
                    {{ label || value }}
                </option>
            </template>
        </select>
    </FieldContainer>
</template>

<script setup>
import FieldContainer from "../FieldContainer";
import {reactive} from "vue";
import {defineField} from "./BaseField";

const { options, old = null, multiple = null, value: fieldValue = null } = defineField()

let fieldOptions = options

if (Array.isArray(options)) {
    fieldOptions = reactive(options.reduce((acc, cur) => {
        // Check whether the option is an object with 'value' and 'label' properties,
        // as this is the format used by v-select components, used in the CP fields.
        // If so, we need to convert it to key/value pairs for the select field,
        // as this is the expected format for the frontend component.
        if (Object.hasOwn(cur, 'value') && Object.hasOwn(cur, 'label')) {
            cur.key = cur.value;
            cur.value = cur.label;
        }

        if(cur.key !== undefined && cur.value !== undefined) {
            acc[cur.key] = cur.value
        }

        return acc
    }, {}))
}

function isSelected(value) {
    if (!old) {
        return false;
    }

    if (multiple) {
        return fieldValue?.includes(value);
    }

    return old === value;
}
</script>
